import { Container, PageContainer } from '@amelio/ui-library';

import { SelectRevieweeContent } from './Content/SelectRevieweeContent';
import { SelectRevieweeHeader } from './SelectRevieweeHeader/SelectRevieweeHeader';

import type { SelectRevieweeProps } from '../types';

export const SelectReviewee = ({
    companyAttributes,
    selectedCompanyAttributes,
    filters,
    reviewees,
    selectedReviewees,
    isLoading,
    selectReviewee,
    onSelectCompanyAttribute,
    onSelectCompanyAttributeOption,
    paginationData,
    isSelfEvaluation,
    searchTerm,
    onSearchChange,
}: SelectRevieweeProps) => {
    return (
        <PageContainer className={'flex flex-col'}>
            <SelectRevieweeHeader isSelfEvaluation={isSelfEvaluation} />

            <Container mt={'page'}>
                <SelectRevieweeContent
                    isSelfEvaluation={isSelfEvaluation}
                    companyAttributes={companyAttributes}
                    selectedCompanyAttributes={selectedCompanyAttributes}
                    filters={filters}
                    reviewees={reviewees}
                    selectedReviewees={selectedReviewees}
                    isLoading={isLoading}
                    selectReviewee={selectReviewee}
                    onSelectCompanyAttribute={onSelectCompanyAttribute}
                    onSelectCompanyAttributeOption={onSelectCompanyAttributeOption}
                    paginationData={paginationData}
                    searchTerm={searchTerm}
                    onSearchChange={onSearchChange}
                />
            </Container>
        </PageContainer>
    );
};
